import { createApp } from 'vue'
import App from './App.vue'
import './styles/app.css'; 

import hljs from 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";

// we do this stupid thing so webpack does not remove it
window.hljs = hljs
createApp(App)
    .use(hljsVuePlugin)
    .mount('#app')

